import styled from 'styled-components/macro';
import { AlertType } from '@yme/atoms/alert';
import { Button } from '@yme/atoms/button';
import { colorAccentSuccess800, colorAccentError900, colorCoreBlack900Base, } from '@yme/tokens/colors';
import { getTextStyles } from '@yme/utils/styles';
export const ButtonStyled = styled(Button) `
  padding: 0;

  ${getTextStyles('Ubuntu', null, 14, 20)};

  color: ${({ alertType }) => {
    switch (alertType) {
        case AlertType.SUCCESS:
            return colorAccentSuccess800;
        case AlertType.ERROR:
            return colorAccentError900;
        default:
            return colorCoreBlack900Base;
    }
}};

  &:hover {
    cursor: pointer;
    background: transparent;
    color: ${({ alertType }) => {
    switch (alertType) {
        case AlertType.SUCCESS:
            return colorAccentSuccess800;
        case AlertType.ERROR:
            return colorAccentError900;
        default:
            return colorCoreBlack900Base;
    }
}};
  }

  text-transform: unset;
  text-decoration: underline;
`;
